import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import ReactGA from "react-ga";
import "react-table/react-table.css";
import "react-datepicker/dist/react-datepicker.css";

import "./index.css";
import App from "./App";
import store from "./reducers/store";
import { unregister } from "./registerServiceWorker";

import "./i18n";

unregister();

ReactGA.initialize("UA-92959005-4", {
  debug: true,
  titleCase: false,
});
ReactDOM.render(
  <BrowserRouter>
    <Provider store={store}>
      <App />
    </Provider>
  </BrowserRouter>,
  document.getElementById("root"),
);

if (module.hot) {
  module.hot.accept();
}



// WEBPACK FOOTER //
// ./src/index.js